import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

export default function Temporizador({ item }) {
  const [tiempoT, setTiempoT] = useState();
  function formato12Horas(hora24) {
    let [horas, minutos] = hora24.split(":");
    let periodo = horas >= 12 ? "p. m." : "a. m.";

    horas = horas % 12;
    horas = horas ? horas : 12; // La hora '0' se convierte en '12'

    // Opcional: Agregar un cero a la izquierda si las horas son menores a 10
    let horasFormateadas = horas < 10 ? "0" + horas : horas;

    return `${horasFormateadas}:${minutos} ${periodo}`;
  }
  let fech =
    item?.detalle && item?.detalle[0]?.selectedTime
      ? item?.detalle[0]?.selectedTime
      : new Date(item.fecha.seconds * 1000);
  let hora =
    fech instanceof Date && !isNaN(fech)
      ? fech.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : formato12Horas(fech);

  useEffect(() => {
    const inter = setInterval(() => {
      let fechaO = new Date(item.fecha.seconds * 1000);
      if (item.detalle[0].selectedDate && item.detalle[0].selectedTime) {
        fechaO = new Date(
          item.detalle[0].selectedDate + "T" + item.detalle[0].selectedTime,
        );
      } else if (item.detalle[0].selectedDate) {
        fechaO = new Date(item.detalle[0].selectedDate + "T00:00:00");
      }
      const actual = new Date();
      const diferenciaMs = fechaO - actual;
      const dif = diferenciaMs / (1000 * 60);
      if (dif <= 0) {
        clearInterval(inter);
      }
      if (!isNaN(dif)) setTiempoT(dif);
    }, 1000);
    return () => clearInterval(inter);
  }, [item.detalle, item.fecha.seconds]);

  return (
    <Row style={{ marginBottom: 5, fontSize: 30 }}>
      <Col
        md={6}
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <i className="bx bx-user icon"></i>
        <Row>
          <Col md={12}>
            <h6>
              <strong>{item.user_name}</strong>
            </h6>
          </Col>

          <Col md={12}>
            <h6>{hora}</h6>
          </Col>
        </Row>
      </Col>
      <Col
        md={6}
        style={{
          flexDirection: "row",
          display: "flex",
          textAlign: "center",
          alignItems: "center",
        }}
      >
        <i className="bx bx-time icon" style={{ fontSize: 24 }}></i>
        <Row>
          <Col md={12}>
            <h6>
              <strong>
                {" "}
                {tiempoT && tiempoT > 0
                  ? "Tiempo restante"
                  : "Tiempo tanscurrido"}
              </strong>
            </h6>
          </Col>
          <Col md={12}>
            {tiempoT && tiempoT > 0 && !isNaN(tiempoT) ? (
              <h5 style={{ color: "#08832c" }}>
                <strong>
                  {tiempoT > 60 ? parseInt(tiempoT / 60) : parseInt(tiempoT)}
                  {tiempoT > 60 ? " Horas" : " minutos"}
                </strong>
              </h5>
            ) : (
              <h5 style={{ color: "#ee2019" }}>
                <strong>
                  {-tiempoT > 60 ? parseInt(-tiempoT / 60) : parseInt(-tiempoT)}
                  {-tiempoT > 60 ? " Horas" : " minutos"}
                </strong>
              </h5>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
